import React, { useEffect, useState, useCallback, useMemo } from "react";
import { withRouter } from "react-router-dom";
import { useGetState } from 'ahooks'
import { Page, Layout, Card, Tabs, Pagination, EmptyState, ButtonGroup,Box, Button, Popover,Icon, ActionList, Toast, Modal, BlockStack, Tooltip } from "@shopify/polaris";
import intl from "../../../../i18n/intl";
import _ from 'lodash';
// * 页面组件
import SearchLoading from '../../../../components/SearchLoading';
import CheckBoxButton from '../../../../components/CheckBoxButton';
import GetGoodReviews from '../../../../components/GetGoodReviews'
import Search from './Search';
import LoadingPage from './LoadingPage';
import TableSelect from './TableSelect';
import OperationModal from './OperationModal';
import ImportFormOther from './ImportFormOther';
import Top3Btn from "./Top3Btn";
import {
  QuestionMarkMinor
} from '@shopify/polaris-icons';
// * api
import {
  reqPostImportProductStore,
  reqGetNewMyProductCount,
  reqGetNewProductList,
  reqPostNewQueueProcess,
  reqPostNewDeleteProduct,
  // reqPostBaseAction,
  reqGetUserSubcribe,
} from '../../../../api';
// * css
import '../index.css';
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { store } from "../../../../store";
import UpgradePlanModal from '../../SubscriptionPaid/components/UpgradePlanModal';
import ImportAliexpressModal from '../../SubscriptionPaid/components/ImportAliexpressModal';
import NoviceImportModal from '../../../../components/NoviceGuidance/NoviceImportModal'
import ChatTitle from './ProductInfo/components/ChatTitle'
import ChatDescription from './ProductInfo/components/ChatDescription'
import ShopifyProductList from "../../ShopifyProducts/ShopifyProductList";
import AppBridge from "../../../../utils/appBridge";
import { changeBannerData } from "../../../../slice";
import { useSelector} from "react-redux";
var aliNumSourcing = 1;
var dalayTime = 5 * 1000;
const ImportListClass = ({callBackFun}) => {
  const [timers, setTimers] = useState([]) // 定时器数组
  const [isInit, setIsInit] = useState(true) // 是否显示骨架屏
  const [loading, setLoading] = useState(false) // 搜索loading
  const [selected, setSelected, getSelected] = useGetState(0) // 选中tabs
  const [list, setList] = useState([]) // 列表数据
  const [total, setTotal] = useState(0) // 数据总数
  const [summary, setSummary] = useState({}) // 列表数据统计
  const [isCheckAll, setIsCheckAll] = useState(false) // 选择所有商品，包括未展示的分页数据
  const [popoverActive, setPopoverActive] = useState(false); // 
  const [importantLimit,setImportantLimit] = useState(0);//商品导入限制
  const [aliImportModal,setAliImportModal] = useState(false);//速卖通产品导入限制
  // const [importantLimitDay,setImportantLimitDay] = useState(0);//商品导入限制
  const [importantDsmModal,setImportantDsmModal] = useState(false);//dsm产品导入限制
  const [shopifyLimitTipsActive,setShopifyLimitTipsActive] = useState(false);//shopify导入产品限制
  const [shopifyLimitTipsActives,setShopifyLimitTipsActives] = useState(false);//shopify导入产品限制
  const [noviceModal,setNoviceModal] = useState(false);//引导视频
  const [temuModal,setTemuModal] = useState(false);//temu弹窗
  const [importParams, setImportParams] = useState({
    isRunPolling: false, // 是否开启导入轮询
    isBulkExecute: false, // 是否正在执行批量操作
    needImportIds: [], // 需要导入店铺的产品id
    needImportAliIds:[],//需要导入速卖通的产品id
    isDeleteFromShopify:false,//是否删除店铺全部
    selectAllMoreChecked:false//是否批量整个tab数据
  }) // 导入操作所有参数
   // chatgpt
   const [chatData,setChatData] = useState({
    chatAction:false,
    user_product_id:'',
    title:'',
    titleModal:false,
    oldTitle:'',
    titleOpen:false,
    titleFc:null,
    dsc:'',
    oldDsc:'',
    dscOpen:false,
    dscModal:false,
    dscFc:null
  })
  const [reviewParams, setReviewParams] = useState({
    open: false, // 好评弹窗开关
    reviewInShopify: true, // 是否在Shopify插件市场评论（评星大于1 代表已评）
    ActiveGetReviewTime: 0, // 上次激活好评弹窗时间戳
    timeToGetReview: false, // 好评弹窗弹出的条件 timeToGetReview为true(导入轮询完成后变true) reviewInShopify为false
  }) // 好评弹窗所有参数
  const [toPage,setToPage] = useState('')
  const [searchParam, setSearchParam, getSearchParam] = useGetState({
    page: 1,
    size: 10,
    q: '',
    selectPublish: ['Not imported'],
    selectProductStatus: []
  })
  const [modalParams, setModalParams] = useState({
    open: false,
    type: '',
    count: 0,
    isBulk: false,
    ids: [],
    recordKey: null,
    checked:false,
    is_inventory:false
  })
  const [otherImportParams, setOtherImportParams] = useState({
    open: false,
    type: '',
  })

  // pagefly
  const [pagefly,setPagefly] = useState(false);
  const handlePageFly = (val) => {
    setPagefly(val)
  }

  const [toast, setToast] = useState(false);
  const [toastError, setToastError] = useState(false);
  const [toastMsg, setToastMsg] = useState("");


  const toggleToast = useCallback(() => setToast((toast) => !toast), []);

  const toastMarkup = toast ? (
    <Toast content={toastMsg} onDismiss={toggleToast} error={toastError} />
  ) : null;

  const toastFun = (msg, error) => {
    setToastError(error);
    setToastMsg(msg);
    setToast(false);
    toggleToast();
  }

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      setIsInit(true)
      getTabs()
      if(AppBridge && AppBridge.exist()) {
        AppBridge.setTitleBar('List Products')
        }
    }
    return () => {
      isMounted = false
      clearAllTimers()
    }
    // eslint-disable-next-line
  }, [])

  // 清空所有定时器
  const clearAllTimers = () => {
    timers.forEach(timer => {
      clearInterval(timer)
    })
  }

  // 展示批量操作
  const bulkOption = useMemo(() => {
    const { recommendCount } = summary
    switch (selected) {
      case 0:
        return true
      case 1:
        return !!recommendCount
      default:
        return false
    }
  }, [summary, selected])
  // 总条数
  const pageMsg = () => {
    const { page, size } = searchParam
    const startNum = (page - 1) * size + 1
    const endNum = page * size > total ? total : page * size;
    return intl.get("Showing {{startNum}} - {{endNum}} of {{total}} results", startNum, endNum, total) +' (Total '+ Math.ceil(total / 10) + ' Page) '
  }
  // 是否存在上一页
  const hasPrevious = useMemo(() => {
    const { page, size } = searchParam
    const maxPageNum = _.ceil(total / size)
    if (page > 1 && page <= maxPageNum) {
      return loading ? false : true
    } else if (page === 1) {
      return false
    }
  }, [total, searchParam, loading])

  // 是否存在下一页
  const hasNext = useMemo(() => {
    const { page, size } = searchParam
    const maxPageNum = _.ceil(total / size)
    if (_.inRange(page, 1, maxPageNum)) {
      return loading ? false : true
    } else if (page === maxPageNum) {
      return false
    }
  }, [total, searchParam, loading])

  // 上一页
  const handlePrev = () => {
    setSearchParam((prevValue) => {
      clearAllTimers()
      setToPage('')
      const params = { ...prevValue }
      params.page = Number(prevValue.page) - 1
      params.q = ''
      getList(params)
      return params
    })
  }

  // 下一页
  const handleNext = () => {
    setSearchParam((prevValue) => {
      clearAllTimers()
      setToPage('')
      const params = { ...prevValue }
      params.page = Number(prevValue.page) + 1
      params.q = ''
      getList(params)
      return params
    })
  }

  /**
   * 获取列表tabs
   */
   const history = useHistory()
    // 请求清空recommend的值 首页recommend横幅只显示1次 点击跳转后请求这个接口就关闭
    const hideRecommend = async () => {
      // const { query } = this.props.location
      const { search } = history.location;
      let url = new URLSearchParams(search);
      let type = url.get("type");
      // if (type === 'dsm_recommend') {
      //   const params = {
      //     type: 'dsm_recommend'
      //   }
      //  let res =  await reqPostBaseAction(params);
      //  if (res.code === '200') {
      //    setSearchParam((prevValue)=>({
      //      ...prevValue,
      //      selectPublish:["Recommend"]
      //    }))
      //    setSelected(1)
      //   getList({
      //     page: 1,
      //     size: 10,
      //     q: '',
      //     selectPublish: ["Recommend"],
      //     selectProductStatus: []
      //   })
      //  }
      //  try {
      //   history.replace('/admin/import-list')
      // } catch (error) {
      //   console.warn(error);
      // }
      // }else{
        if (type === 'Listed') {
          setSearchParam((prevValue)=>({
            ...prevValue,
            selectPublish:["Listed"]
          }))
          setSelected(2)
         getList({
           page: 1,
           size: 10,
           q: '',
           selectPublish: ["Listed"],
           selectProductStatus: []
         })
        }else {
          getList(getSearchParam())
        }
      //  }
    }
  const getTabs = async (type) => {
    const response = await reqGetNewMyProductCount();
    if(response?.code === '200') {
      setSummary(response?.data)
      const activeTabs = (
        [
          {
            id: 'not-imported',
            content: intl.get("Not Listed") + ' (' + response?.data?.notImportedCount + ')',
            accessibilityLabel: intl.get("Not Listed"),
            value: 'Not imported',
            panelID: 'not-imported',
          },
          {
            id: 'imported',
            content: intl.get("Listed") + ' (' + response?.data?.importedCount + ')',
            accessibilityLabel: intl.get("Listed"),
            value: 'Imported',
            panelID: 'imported',
          },
          {
            id: 'deleted',
            content: intl.get("Deleted") + ' (' + response?.data?.deleteCount + ')',
            accessibilityLabel: intl.get("Deleted"),
            value: 'Deleted',
            panelID: 'deleted',
          },
          {
            id: 'store_products',
            content: <div className="remarkcontainer">
            {intl.get("Store Products")}
            {
              <div className="remarkarea">
                <Tooltip preferredPosition="above" content={intl.get('Sync and display all products in your Shopify store, including those imported from Dropshipman and products brought in from other platforms.')}>
                  <Icon source={QuestionMarkMinor} backdrop={true} />
                </Tooltip>
              </div>
            }
          </div>,
            accessibilityLabel: intl.get("Store Products"),
            value: 'store_products',
            panelID: 'store_products',
          }
        ]
      )
      // if (response?.data?.recommendCount) {
      //   activeTabs.splice(1, 0, {
      //     id: 'recommend',
      //     content: intl.get("Recommend") + ' (' + response?.data?.recommendCount + ')',
      //     accessibilityLabel: intl.get('Recommend'),
      //     value: 'Recommend',
      //     panelID: 'recommend',
      //   })
      // }
      setTabs(activeTabs)
      let res = await reqGetUserSubcribe();
      if (res.code === '200') {
        setImportantLimit(Number(res?.data?.limit?.aliexpress + res?.data?.limit?.aliexpress_job))
        // setImportantLimitDay(res?.data?.day?.ali_product_num)
      }
    if (type) {
      getList({
        page: 1,
        size: 10,
        q: '',
        selectPublish:["Not imported"],
        selectProductStatus: [],
        })
        setSearchParam((prevValue)=>({
          ...prevValue,
            page: 1,
            size: 10,
            q: '',
            selectPublish:["Not imported"],
            selectProductStatus: [],
        }))
    }else  if (Number(response?.data?.recommendCount) > 0) {
      hideRecommend()
    }else {
      getList(getSearchParam())
      clearAllTimers()
    }
    } else {
      setIsInit(false)
      // toastFun(response?.msg, true)
      store.dispatch(changeBannerData({bannerData:{
        show:true,
        desc:response.msg
      }}));
    }
  }

   
  /**
   * 获取列表数据
   */
  const getList = async (params) => {
    setLoading(true)
    setIsCheckAll(false)
    // params.selectPublish = tabs[getSelected()].value ? [tabs[getSelected()].value] : []
    // 格式化参数
    let tab = 1;
    switch (params?.selectPublish[0]) {
      case "Not imported":
        tab = 1;
        break;
      // case "Recommend":
      //   tab = 2;
      //   break;
      case "Imported":
        tab = 3;
        break;
      case "Deleted":
        tab = 4;
        break;
      default:
        break;
    }
    let status = 0;
    switch (params?.selectProductStatus[0]) {
      case 'On Selling':
        status = 1
        break;
      case 'Offline':
        status = 2
        break;
      default:
        status = 0
        break;
    }
    const formatParams = {
      page:params.page,
      size:params.size,
      q:params.q,
      import_status: tab,
      product_status:status,
    }

    const response = await reqGetNewProductList(formatParams)
    if (response?.code === '200') {
     
      let getData = response?.data;
      setList(getData?.result)
      setTotal(getData.count)
      setIsInit(false)
      setLoading(false)
      const needImportIdsArray = getData?.result?.filter(item => item.status === 2)?.map(item => item.id)
      const needImportAliIdsArray = getData?.result?.filter(item => item.productStatus === 0)?.map(item => item.id)
      setModalParams((prevValue)=>({...prevValue,checked:getData?.auto_publish,is_inventory:getData?.auto_inventory}))
      setImportParams((prevValue) => ({ ...prevValue, needImportIds: needImportIdsArray,needImportAliIds:needImportAliIdsArray }))
      setReviewParams((prevValue) => ({ ...prevValue, reviewInShopify: !!(getData.review > 0), ActiveGetReviewTime: getData.time * 1000 }))

      // 触发评价弹窗
      if (reviewParams?.timeToGetReview && !importParams?.reviewInShopify) {
        setReviewParams((prevValue) => ({ ...prevValue, open: true }))
      }
      // 是否有正在导入的速卖通产品
      if (needImportAliIdsArray.length > 0 && importParams?.isRunPolling === false) {
        const params = { ali_ids: needImportAliIdsArray , sids:[] }
        pollingImportProcess(params, '开始')
      }
      if (needImportIdsArray.length > 0 && importParams?.isRunPolling === false) {
        const params = { ali_ids: [] , sids: needImportIdsArray }
        pollingImportProcess(params, '开始')
      }
    } else {
      setIsInit(false)
      // toastFun(response?.msg, true)
      store.dispatch(changeBannerData({bannerData:{
        show:true,
        desc:response.msg
      }}));
    }
  }
  const language = useSelector(state => state.languageReducer.language);
  // tabs栏
  // const tabs = useMemo(() => {
  //   const activeTabs = (
  //     [
  //       {
  //         id: 'not-imported',
  //         content: intl.get("Not Listed") + ' (' + summary?.notImportedCount + ')',
  //         accessibilityLabel: intl.get("Not Listed"),
  //         value: 'Not imported',
  //         panelID: 'not-imported',
  //       },
  //       {
  //         id: 'imported',
  //         content: intl.get("Listed") + ' (' + summary?.importedCount + ')',
  //         accessibilityLabel: intl.get("Listed"),
  //         value: 'Imported',
  //         panelID: 'imported',
  //       },
  //       {
  //         id: 'deleted',
  //         content: intl.get("Deleted") + ' (' + summary?.deleteCount + ')',
  //         accessibilityLabel: intl.get("Deleted"),
  //         value: 'Deleted',
  //         panelID: 'deleted',
  //       },
  //       {
  //         id: 'store_products',
  //         content: <div className="remarkcontainer">
  //         {intl.get("Store Products")}
  //         {
  //           <div className="remarkarea">
  //             <Tooltip preferredPosition="above" content={intl.get('Sync and display all products in your Shopify store, including those imported from Dropshipman and products brought in from other platforms.')}>
  //               <Icon source={QuestionMarkMinor} backdrop={true} />
  //             </Tooltip>
  //           </div>
  //         }
  //       </div>,
  //         accessibilityLabel: intl.get("Store Products"),
  //         value: 'store_products',
  //         panelID: 'store_products',
  //       }
  //     ]
  //   )
  //   if (summary?.recommendCount) {
  //     activeTabs.splice(1, 0, {
  //       id: 'recommend',
  //       content: intl.get("Recommend") + ' (' + summary?.recommendCount + ')',
  //       accessibilityLabel: intl.get('Recommend'),
  //       value: 'Recommend',
  //       panelID: 'recommend',
  //     })
  //   }
  //   return activeTabs;
  //   // eslint-disable-next-line
  // }, [summary])
  let defalutData = useMemo(()=>{
    let activeTabs = (
      [
        {
          id: 'not-imported',
          content: intl.get("Not Listed") + ' (' + 0 + ')',
          accessibilityLabel: intl.get("Not Listed"),
          value: 'Not imported',
          panelID: 'not-imported',
        },
        {
          id: 'imported',
          content: intl.get("Listed") + ' (' + 0 + ')',
          accessibilityLabel: intl.get("Listed"),
          value: 'Imported',
          panelID: 'imported',
        },
        {
          id: 'deleted',
          content: intl.get("Deleted") + ' (' + 0 + ')',
          accessibilityLabel: intl.get("Deleted"),
          value: 'Deleted',
          panelID: 'deleted',
        },
        {
          id: 'store_products',
          content: <div className="remarkcontainer">
          {intl.get("Store Products")}
          {
            <div className="remarkarea">
              <Tooltip preferredPosition="above" content={intl.get('Sync and display all products in your Shopify store, including those imported from Dropshipman and products brought in from other platforms.')}>
                <Icon source={QuestionMarkMinor} backdrop={true} />
              </Tooltip>
            </div>
          }
        </div>,
          accessibilityLabel: intl.get("Store Products"),
          value: 'store_products',
          panelID: 'store_products',
        }
      ]
    )
    if (language) {
      activeTabs = (
        [
          {
            id: 'not-imported',
            content: intl.get("Not Listed") + ' (' + 0 + ')',
            accessibilityLabel: intl.get("Not Listed"),
            value: 'Not imported',
            panelID: 'not-imported',
          },
          {
            id: 'imported',
            content: intl.get("Listed") + ' (' + 0 + ')',
            accessibilityLabel: intl.get("Listed"),
            value: 'Imported',
            panelID: 'imported',
          },
          {
            id: 'deleted',
            content: intl.get("Deleted") + ' (' + 0 + ')',
            accessibilityLabel: intl.get("Deleted"),
            value: 'Deleted',
            panelID: 'deleted',
          },
          {
            id: 'store_products',
            content: <div className="remarkcontainer">
            {intl.get("Store Products")}
            {
              <div className="remarkarea">
                <Tooltip preferredPosition="above" content={intl.get('Sync and display all products in your Shopify store, including those imported from Dropshipman and products brought in from other platforms.')}>
                  <Icon source={QuestionMarkMinor} backdrop={true} />
                </Tooltip>
              </div>
            }
          </div>,
            accessibilityLabel: intl.get("Store Products"),
            value: 'store_products',
            panelID: 'store_products',
          }
        ]
      )
    }
    return activeTabs;
  },[language]);
  const [tabs,setTabs] = useState(defalutData)

  const getDefalutData = (data)=>{
    const activeTabs = (
      [
        {
          id: 'not-imported',
          content: intl.get("Not Listed") + ' (' + summary?.notImportedCount + ')',
          accessibilityLabel: intl.get("Not Listed"),
          value: 'Not imported',
          panelID: 'not-imported',
        },
        {
          id: 'imported',
          content: intl.get("Listed") + ' (' + summary?.importedCount + ')',
          accessibilityLabel: intl.get("Listed"),
          value: 'Imported',
          panelID: 'imported',
        },
        {
          id: 'deleted',
          content: intl.get("Deleted") + ' (' + summary?.deleteCount + ')',
          accessibilityLabel: intl.get("Deleted"),
          value: 'Deleted',
          panelID: 'deleted',
        },
        {
          id: 'store_products',
          content: <div className="remarkcontainer">
          {intl.get("Store Products")}
          {
            <div className="remarkarea">
              <Tooltip preferredPosition="above" content={intl.get('Sync and display all products in your Shopify store, including those imported from Dropshipman and products brought in from other platforms.')}>
                <Icon source={QuestionMarkMinor} backdrop={true} />
              </Tooltip>
            </div>
          }
        </div>,
          accessibilityLabel: intl.get("Store Products"),
          value: 'store_products',
          panelID: 'store_products',
        }
      ]
    )
    // if (summary?.recommendCount) {
    //   activeTabs.splice(1, 0, {
    //     id: 'recommend',
    //     content: intl.get("Recommend") + ' (' + summary?.recommendCount + ')',
    //     accessibilityLabel: intl.get('Recommend'),
    //     value: 'Recommend',
    //     panelID: 'recommend',
    //   })
    // }
    setTabs(activeTabs)
}
  useEffect(() => {
    let isMount = false;
    if (!isMount) {
      getDefalutData(defalutData);
    }
    return () => {
      isMount = true;
    };
    // eslint-disable-next-line
  },[defalutData]);
  // tabs切换
  const handleTabChange = useCallback((selectedTabIndex) => {
    setSelected(selectedTabIndex);
    setToPage('')
    if (tabs[selectedTabIndex].value === 'store_products') {
      return
    }
    setSearchParam((preState) => {
      clearAllTimers()
      const params = { ...preState }
      params.selectPublish = tabs[selectedTabIndex].value ? [tabs[selectedTabIndex].value] : []
      params.selectProductStatus = []
      params.page = 1
      params.size = 10
      params.q = ''
      return params
    })

    getTabs()
    // eslint-disable-next-line
  }, [tabs])

  // 筛选
  const handleSearch = useCallback((data) => {
    // 判断当前选中的tab是否和筛选条件的相同 不同跳转到对应tab
    const newSelectedIndex = _.findIndex(tabs, ['value', data?.selectPublish?.[0]])
    const currSelectedIndex = _.findIndex(tabs, ['value', tabs[getSelected()]?.value])
    if (newSelectedIndex !== -1 && currSelectedIndex !== -1 && newSelectedIndex !== currSelectedIndex) {
      handleTabChange(newSelectedIndex)
      return
    }
    setSearchParam((prevValue) => {
      clearAllTimers()
      const params = { ...prevValue, ...data,page:1}
      getList(params)
      return params
    })
    
    // eslint-disable-next-line
  }, [getSearchParam(), tabs])

  // 全选
  const checkAll = () => {
    const checkList = [...list]
    if (getSearchParam()?.selectPublish[0] === 'Not imported' || getSearchParam()?.selectPublish[0] === 'Recommend') {
      let lists = checkList.map((item) => {
        if ((item.productStatus === 1 && item.status !== 2) ) {
          let data = item;
          if (checkStatus.checked === 'indeterminate') {
            data =  {...data,checked : 1}
          } else {
            data = {...data,checked : checkStatus.checked === true ? 0 : 1}
          }
          return data;
        }else {
          return item
        }
      })
      setList(lists)
    }else{
      // const checkStatusList = _.filter(checkList, (item) => item.status !== 2)
      
      let lists = checkList.map((item) => {
        if (item.status !== 2 && item.productStatus !== 4 ) {
          let data = item;
          if (checkStatus.checked === 'indeterminate') {
            data =  {...data,checked : 1}
          } else {
            data = {...data,checked : checkStatus.checked === true ? 0 : 1}
          }
          return data;
        }else {
          return item
        }
      })
      setList(lists)
    }
    
  }

  // const BatchdeleteImportProduct = async () => {
  //   let _data = this.state.productsData;
  //   let idsArray = [];
  //   let recordKeyArray = [];
  //   for (let i = 0; i < _data.length; i++) {
  //     if (_data[i].checked === 1) {
  //       idsArray.push(_data[i].id);
  //       recordKeyArray.push(i);
  //     }
  //   }

  //   this.setState({
  //     isBulkOperationsRequest: true,
  //   });

  //   // 请求删除操作 成功后移除记录
  //   const params = {
  //     selectPublish: JSON.stringify(this.state.filterStatus),
  //     ids: JSON.stringify(idsArray),
  //     type: this.state.selectAllMoreChecked ? 1 : 0,
  //     del: this.state.isDeleteFromShopify ? 1 : 0
  //   };
  //   const response = await reqPostDelDropshipmanProduct(params)
  //   if (response.code === '200') {

  //     for (let j = 0; j < recordKeyArray.length; j++) {
  //       _data.splice(_data[recordKeyArray[j]], 1);
  //     }

  //     this.setState({
  //       productsData: _data,
  //       isBulkOperationsRequest: false,
  //       page: 1,
  //     }, () => {
  //       this.updatePageDetail();
  //     });
  //     setTimeout(() => {
  //       if (response.data.count === 0) {
  //         this.setState({
  //           importStatusSelected: 1,
  //           filterStatus: ['Not imported']
  //         }, () => {
  //           this.getDropshipmanProductList(true)
  //         })
  //       } else {
  //         this.getDropshipmanProductList(true)
  //       }
  //     }, 600);

  //     this.toggleToast(response.msg, false);

  //     if (this.state.selectAllMoreChecked) {
  //       window.location.reload();
  //     }
  //   } else {

  //     this.setState({
  //       isBulkOperationsRequest: false
  //     });
  //     this.toggleToast(response.msg);
  //   }
  // }
  // [单个/批量] 删除 产品 ：数组key 数据库(shopify产品表)记录 id
 const deleteImportProduct = async (RecordKey, id,type) => {
    let idsArray = [];
    if (id.length > 0) {
      idsArray = [...id]
    }else{
    idsArray.push(id);
    }
    // 请求删除操作 成功后移除记录
    let tab = 1;
    
    switch (searchParam.selectPublish[0]) {
      case "Not imported":
        tab = 1;
        break;
      // case "Recommend":
      //   tab = 2;
      //   break;
      case "Imported":
        tab = 3;
        break;
      case "Deleted":
        tab = 4;
        break;
      default:
        break;
    }
    const params = {
      // selectPublish: this.state.importStatusSelected,
      selectPublish:tab,
      ids: JSON.stringify(idsArray),
      del: importParams.isDeleteFromShopify ? 1 : 0
    };
    if (type) {//是否批量删
      params.type = isCheckAll ? 1 : 0
    }
   
    const response = await reqPostNewDeleteProduct(params)
    if (response.code === '200') {
      // let _data = list;
      // _data.splice(RecordKey, 1);

      // setList(_data);
      if (idsArray.length === list.length) {
        setSearchParam((prevValue)=>({
          ...prevValue,
          page:1,
          size:10,
          selectPublish:["Not imported"]
        }))
        setSelected(0)
        getTabs(true)
      }else{
        getTabs()
      }

      toastFun(intl.get('Removed successfully'), false);
    } else {
    //  toastFun(response.msg, true);
     store.dispatch(changeBannerData({bannerData:{
      show:true,
      desc:response.msg
    }}));
    }
  }

  /**
   * 全选按钮状态
   * true：全选 / indeterminate: 部分选中 / false：未选择
   * @returns {Object} { checked: 选中状态, num: 选中数量 }
   */
   
  const checkStatus = useMemo(() => {
    if ((getSearchParam()?.selectPublish[0] === 'Not imported' || getSearchParam()?.selectPublish[0] === 'Recommend')) {
    
    const checkStatusList = _.filter(list, (item) => item?.checked === 1)
    const onSellingList = _.filter(list, (item) => item?.productStatus === 1 && item?.status !== 2)
    let ids = []
    for (let i = 0; i < onSellingList.length; i++) {
      if (onSellingList[i].checked === 1) {
        ids.push(onSellingList[i].id)
      } 
    }
    if (_.isEmpty(checkStatusList)) {
      return {
        checked: false,
        num: checkStatusList.length,
        ids
      }
    } else if (checkStatusList.length > 0 && checkStatusList.length === onSellingList.length) {
      return {
        checked: true,
        num: checkStatusList.length,
        ids
      }
    }else{
    return {
      checked: 'indeterminate',
      num: checkStatusList.length,
      ids
    }
    }
  }else{
    const checkStatusList = _.filter(list, (item) => item?.checked === 1)
    const onSellingList = _.filter(list, (item) => item?.status !== 2 && (item.productStatus !== 4) )
    let ids = []
    for (let i = 0; i < onSellingList.length; i++) {
      if (onSellingList[i].checked === 1) {
        ids.push(onSellingList[i].id)
      } 
    }
    if (_.isEmpty(checkStatusList)) {
      return {
        checked: false,
        num: checkStatusList.length,
        ids
      }
    } else if (checkStatusList.length > 0 && checkStatusList.length === onSellingList.length) {
      return {
        checked: true,
        num: checkStatusList.length,
        ids
      }
    }else{
    return {
      checked: 'indeterminate',
      num: checkStatusList.length,
      ids
    }
    }
  }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list])
  // 修改商品数据
  const changeProduct = (data) => {
    const latestList = [...list]
    _.forEach(list, (item) => {
      if (item.id === data.id) {
        _.assign(item, data)
      }
    })
    setIsCheckAll(false)
    setList(latestList)
  }

  /**
   * 批量操作弹窗回调
   * open 弹窗状态
   * reRequest 是否重新请求
   */
  const handleOnChange = (open) => {
    setModalParams((prevValue) => ({ ...prevValue, open: open }))
  }

  /**
   * 处理导入回调
   */
  // 批量
  const handleImportCb = async (recordKey, params) => {
    setShopifyLimitTipsActives(false)
    let lists = list.map((item) => {
         let data = {...item,checked : 0 }
        return data;
    })
    setList(lists)
    const response = await reqPostImportProductStore({...params,ids:JSON.stringify(params.ids)})//导入产品到店铺
    if (response.code === '200') {
      // if (response.data === 1) {
        let _list = [...list]
        for (let i = 0; i < _list.length; i++) {
          if (_list[i].checked) {
            let _collapsibleShow = _list[i].collapsibleShow
            _list[i].uploading = 1
            _list[i].status = 2
            _list[i].checked = 0
            _list[i].collapsibleShow = _collapsibleShow === 1 ? 0 : 1
           }
        }
      setList(_list)
      if (!importParams?.isRunPolling) {
        // setImportParams((prevValue) => ({ ...prevValue, isRunPolling: true }))
        // 启动轮询
        const { ids } = params
        pollingImportProcess({ sids:ids,ali_ids:importParams.needImportAliIds })
        // 测试数买通轮询
        // testPolling()

      }
      // }
    }else{
      if (response.code === '1000') {
        setShopifyLimitTipsActive(true);
      }else if (response.code === '1001') {
        setShopifyLimitTipsActive(true);
        setShopifyLimitTipsActives(true)
      }else{
      // toastFun(response.msg, true)
      store.dispatch(changeBannerData({bannerData:{
        show:true,
        desc:response.msg
      }}));
      }
    }
  }
  // 单个导入轮询
  const handleSingleImportCb = async (recordKey, params) => {
    const response = await reqPostImportProductStore({...params,ids:JSON.stringify(params.ids),type:0})//导入产品到店铺
    if (response.code === '200') {
        let _list = [...list]
        for (let i = 0; i < _list.length; i++) {
          for (let j = 0; j < params.ids.length; j++) {
            if (_list[i].id === params.ids[j]) {
              _list[i].status = 2
              _list[i].checked = 0
            }
          }
        }
      setList(_list)
      // getTabs()
      if (!importParams?.isRunPolling) {
        // setImportParams((prevValue) => ({ ...prevValue, isRunPolling: true }))
        const { ids } = params
        pollingImportProcess({ sids:ids,ali_ids:importParams.needImportAliIds })
        // 启动轮询
        // 测试数买通轮询
        // testPolling()

      }
      // }
    }else{
      if (response.code === '1000') {
        setShopifyLimitTipsActive(true);
      }else if (response.code === '1001') {
        setShopifyLimitTipsActive(true);
        setShopifyLimitTipsActives(true)
      }else{
      // toastFun(response.msg, true)
      store.dispatch(changeBannerData({bannerData:{
        show:true,
        desc:response.msg
      }}));
      }
    }
  }
  /**
   * 轮询导入状态 
   */
   
  const pollingImportProcess = (params, str) => {
    clearAllTimers()
    const { sids,ali_ids} = params;
    
    setImportParams((prevValue) => ({ ...prevValue, needImportAliIds: ali_ids,needImportIds:sids }))
    setIntervalPolling(handleImportProcess(params), dalayTime, `模拟速卖通导入轮询 ${str}`,params)
  }
  
  // 轮询公共方法
  const setIntervalPolling = (func, duration, str,params) => {
    // func(params)
    // const timer = setInterval(() => {
    //   func().then((response) => {
    //     if (response === 200) {
    //       clearInterval(timer);
    //     }
    //   })
    // }, duration);
    const timer = setInterval(() => {
      handleImportProcess(params).then((response) => {
            if (response === 200) {
              clearInterval(timer);
            }
          })
    }, duration);
    let timerArr = timers
    timerArr.push(timer)
    setTimers(timerArr)
  }

  
  // 处理轮询接口(真正的接口)
  const handleImportProcess = async (param) => {
    if (param.ali_ids.length > 0 || param.sids.length > 0) {
    const params = {
      product_ids: JSON.stringify(param.ali_ids),
      shopify_ids: JSON.stringify(param.sids)
    }
    // const response = await reqPostDropshipmanImportProcess(params)
    const response = await reqPostNewQueueProcess(params)

    if (response.code === "200") {
      aliNumSourcing = aliNumSourcing + 1 ; //导入速卖通产品轮询限制当轮询为20的时候修改
      
      if (response.data === 1) {
        
          setImportParams((prevValue) => ({ ...prevValue, isBulkExecute: false,isRunPolling: false ,timeToGetReview: true}))
          if (response.count === 0) {
            setSelected(0)

            // 如果没有推荐数量则切换到第一个tabs
            // searchParam.selectPublish = ["Not imported"]
            setSearchParam((prevValue)=>({
              ...prevValue,
              selectPublish:["Not imported"]
            }))
          }
          getTabs()
        aliNumSourcing = 1;
        dalayTime = 5 * 1000;
        return 200
      }
      if (aliNumSourcing === 12) {
        dalayTime = 12 * 1000;
        clearAllTimers()
        setIntervalPolling(handleImportProcess(param), dalayTime,'',param)
      }else if (aliNumSourcing === 22) {
        dalayTime = 15 * 1000;
        clearAllTimers()
        setIntervalPolling(handleImportProcess(param), dalayTime,'',param)
      }else if (aliNumSourcing === 46) {
        dalayTime = 30 * 1000;
        clearAllTimers()
        setIntervalPolling(handleImportProcess(param), dalayTime,'',param)
      }
    } else {
      if (response.code === '429') {
        clearAllTimers()
      }
      store.dispatch(changeBannerData({bannerData:{
        show:true,
        desc:response.msg
      }}));
      return 200
    }
  }
}
  // 点击aliexpress 1688 导入产品的按钮 及 这2个按钮触发弹窗里的add product
  const handleOtherOnChange = (type, open) => {
    let person = store.getState().languageReducer.subScriptData;
    // 导入限制&& importantLimit >= 5 
    if (person.level === 0 ) {
      setImportantDsmModal(true)
      return;
    }
    if ((person.level === 4 && importantLimit >= 100)) {
      setAliImportModal(true)
      return
    }
    setOtherImportParams((prevValue) => ({ ...prevValue, open, type }))
    // 当open是false 证明请求成功
   
    if(!open && type === 'AliExpress') {
      getList(getSearchParam())
      setImportantLimit(importantLimit+1)
      const params = {ali_ids: importParams?.needImportAliIds,sids:[] }
      pollingImportProcess(params, '开始')
    }
    if(!open && type === '1688'){
      getList(getSearchParam())//1688不用轮询
    }
  }

  const handleModal = (type, ids = [], isBulk = false, isBulkEdit = true,recordKey) => {
    // isBulkEdit && togglePopoverActive()
    setImportParams((prevValue)=>{
      const param = [...prevValue.needImportIds,...ids]
      const params = {...prevValue,needImportIds:param}
      return params;
    })
    setModalParams((prevValue) => ({ ...prevValue, open: true, type, count: checkStatus.num, isBulk, ids:ids.length>0 ? ids:checkStatus?.ids,recordKey }))
  }

  // 评价弹窗关闭回调
  const callBackReviewFunc = () => {
    setReviewParams((prevValue) => ({ ...prevValue, open: false }))

  }
  // 批量编辑浮层状态
  const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), []);

  const activator = (<Button disabled={importParams?.isBulkExecute} onClick={togglePopoverActive} disclosure>{intl.get("More actions")}</Button>);

  // 产品列表内容
  const listContent = _.map(list, (item, key) => {
    return (
      <TableSelect
        key={key}
        data={item}
        chatData={chatData}
        setChatData={setChatData}
        list={list}
        setList={setList}
        recordKey={key}
        currTab={searchParam?.selectPublish}
        onChange={changeProduct}
        callback={handleModal}
        callBackFun={callBackFun}
        currentSelected={getSelected()}
        deleteImportProduct={deleteImportProduct}
        handlePageFly={handlePageFly}
      />
    )
  })

   // handel shopify limit modal
  const handleShopifyLimitModal = () => {
    setShopifyLimitTipsActive(false)
  }
 // Shopify limit modal
 const ShopifyLimitTipsModal = (
  <Modal
    open={shopifyLimitTipsActive}
    onClose={handleShopifyLimitModal}
    title={intl.get("Limit reminder")}
    secondaryActions={[{
      content: intl.get("Got it"),
      onAction: handleShopifyLimitModal
    }]}
  >
    <Modal.Section>
      <p>
        {shopifyLimitTipsActives ? intl.get("Shopify daily import product limit reached. Please try again after 24h.") : intl.get("Shopify daily variant creation limit reached. Please try again after 24h.")}
        {intl.get("Please see ")}
        <Button plain textAlign="left" external={true} url='https://help.shopify.com/en/manual/products/variants/add-variants#considerations-for-adding-variants'>
          https://help.shopify.com/en/manual/products/variants/add-variants#considerations-for-adding-variants
        </Button>
      </p>
    </Modal.Section>
  </Modal>)


const TemuModal = (
  <Modal
    size="large"
    open={temuModal}
    onClose={()=>setTemuModal(false)}
    title={intl.get("Import products from TEMU")}
  >
    <Modal.Section>
      <div className="temu_content_modal">
        <div>
       {intl.get("Importing TEMU products requires the installation of the Dropshipman Google Extension. Please follow these steps:")}
        <p> {intl.get("1. Download and install the")} <a style={{color: "#4584FE",display:'inline-flex'}} href={'https://chromewebstore.google.com/detail/dropshipman-aliexpresstem/bobhjedlciclpchpelkgiojkmmfgnihg'} target='_blank' rel="noopener noreferrer"> {intl.get("Dropshipman Google Extension.")} <img width={20} height={20} src='/share_icon.png' alt='dsmshipman'></img> </a> </p>
        <p> {intl.get("2. Log in to the Dropshipman Google Extension using your Dropshipman account.")}</p>
        <p> {intl.get("3. Visit the TEMU product details page, and click the \"Add to my product list\" button to collect the product.")} <a style={{color: "#4584FE",display:'inline-flex'}} href={'https://www.temu.com/'} target='_blank' rel="noopener noreferrer">https://www.temu.com/<img width={20} height={20} src='/share_icon.png' alt='dsmshipman'></img> </a></p>
        <p style={{textAlign:'center',marginTop:'10px'}}>
          <img style={{width:'100%'}} src='/temu/image_banner.png' alt='dsmshipman' />
        </p>
        </div>
      </div>
    </Modal.Section>
  </Modal>)
  const pageContent = (
    <div id="ImportList">
      <Page  fullWidth={true}>
       <Layout>
          <Layout.Section>
            {/* <div className='novice_content' style={{marginBottom:'16px'}}>
            <div className="novice_left Polaris-Header-Title">
            {intl.get('List Products')}
            </div>
            <div className='novice_right'>
              <img height={60} src='/novice/small_video.png' alt='dropshipman' onClick={()=>setNoviceModal(true)}/>
            </div>
            </div> */}
            <Box className='list_product_head'>
            {/* 3个入口 */}
            <Box className='list_product_head_button'>
            <Top3Btn onChange={handleOtherOnChange} callChange={()=>setTemuModal(true)} setNoviceModal={setNoviceModal}/>
            </Box>
            
            </Box>
            <Card>
              <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
              {tabs[selected].value === 'store_products' && <Box>
              <ShopifyProductList />
            </Box> }
              </Tabs>
              {/* 搜索框 */}
                
              {tabs[selected].value !== 'store_products' &&  <Box>
                <Search
                  onSearch={handleSearch}
                  data={{
                    searchParam: searchParam,
                    recommend: !!summary?.recommendCount
                  }}
                />

                {/* 更多操作按钮 */}
               {list.length >0 && <div className="flex mt-5" style={{ display: 'flex', marginTop: '1.25rem' }}>
                  <ButtonGroup segmented>
                    <CheckBoxButton checked={checkStatus.checked} onChange={checkAll}>
                      {checkStatus.num === 0
                        ? intl.get('Select all')
                        : `${checkStatus.num}${isCheckAll ? '+' : ''} ${intl.get('selected')}`}
                    </CheckBoxButton>

                    {/* 勾选之后才显示 */}
                    {checkStatus.checked && bulkOption && (
                      <Button disabled={importParams?.isBulkExecute} onClick={() => handleModal('import', checkStatus?.ids, true, false)}>{intl.get('List products')}</Button>
                    )}
                    {checkStatus.checked && (
                      <Button disabled={importParams?.isBulkExecute} onClick={() => handleModal('delete', checkStatus?.ids, true, false)}>{intl.get('Remove products')}</Button>
                    )}
                    {checkStatus.checked && bulkOption && (
                      <Popover
                        active={popoverActive}
                        activator={activator}
                        onClose={togglePopoverActive}
                      >
                        <ActionList
                          actionRole="menuitem"
                          items={[
                            {
                              content: intl.get('Bulk edit collections'),
                              onAction: () => handleModal('collections')
                            },
                            {
                              content: intl.get('Bulk edit tags'),
                              onAction: () => handleModal('tags')
                            },
                            {
                              content: intl.get('Bulk edit product type'),
                              onAction: () => handleModal('type')
                            }]}
                        />
                      </Popover>
                    )}
                  </ButtonGroup>
                  {/* 全选后才显示 */}
                  {checkStatus.checked && checkStatus.num === list.length && checkStatus.num === 10 && (
                    <Button onClick={() => setIsCheckAll((active) => !active)} variant="plain">
                      <div className="ml-3" style={{ marginLeft: '0.75rem' }}>
                        {isCheckAll
                          ? intl.get('All products in your store selected. Undo')
                          : intl.get('Select all {{size}}+ products', searchParam?.size)}
                      </div>
                    </Button>
                  )}
                </div>}

                {/* 列表为空时 */}
                {_.isEmpty(list) && (
                  <div className="emptyWithImg">
                    {/* 搜索loading */}
                    {loading && <SearchLoading />}

                    <EmptyState heading={intl.get('No product found')} image="/empty.svg">
                      <p style={{ marginBottom: '0' }}>
                        {intl.get('Please add products and import to your store')}
                      </p>
                    </EmptyState>
                  </div>
                )}
                 </Box>}
            </Card>
           
            {tabs[selected].value !== 'store_products' && <Box>
            {!_.isEmpty(list) && (
              <>
                <div className="ImportListSearchLoading">
                  {/* 搜索loading */}
                  {loading && <SearchLoading />}

                  {/* 表格数据 */}
                  <BlockStack gap="400">
                  {listContent}
                  </BlockStack>
                  {ShopifyLimitTipsModal}
                </div>

                {/* 分页 */}
                <div className="ImportListPagination">
                  <Pagination
                    label={pageMsg()}
                    hasPrevious={hasPrevious}
                    hasNext={hasNext}
                    onPrevious={handlePrev}
                    onNext={handleNext}
                  />
                   <div>
                  <input
                    className="Page_input"
                    type="text"
                    value={toPage}
                    maxLength={"8"}
                    onChange={(e) => {
                      if (Number.isInteger(Number(e.target.value))) {
                        if ((e.target.value > Math.ceil(total / 10) || e.target.value <= 0) && e.target.value !== '') {
                          setToPage(1)
                        }else{
                       setToPage(e.target.value)
                        }
                      }
                    }}
                  />
                  <span
                    className="Page_Jump"
                    onClick={() => {
                      if (Math.ceil(total / 10) === 1) return false;
                      let page = 1;
                      if (Math.ceil(total / 10) >= toPage) {
                        page = toPage;
                      }
                      if (
                        Math.ceil(total / 10) > 1 &&
                        Math.ceil(total / 10) <= toPage
                      ) {
                        page = toPage;
                      }
                      if (page === '') {
                        return
                      }

                      setSearchParam((prevValue) => {
                        clearAllTimers()
                        const params = { ...prevValue,page:page }
                        getList(params)
                        return params
                      })
                    }}
                  >
                    {intl.get("Go to")}
                  </span>
                </div>
                </div>
              </>
            )}
            </Box>}
          </Layout.Section>
           {/* chatgpt */}
        {chatData.titleModal && <ChatTitle chatData={chatData} setChatData={setChatData}/>}
        {chatData.dscModal && <ChatDescription chatData={chatData} setChatData={setChatData}/>}
        {TemuModal}
        {/* 批量弹窗 */}
        <OperationModal
          data={{
            open: modalParams?.open,
            type: modalParams?.type,
            count: modalParams?.count,
            isBulk: modalParams?.isBulk,
            ids: modalParams?.ids,
            all: +isCheckAll,
            recordKey: modalParams?.recordKey,
            content:list,
            isDeleteFromShopify:importParams.isDeleteFromShopify,
            checked:modalParams?.checked,
            is_inventory:modalParams?.is_inventory
          }}
          currTab={searchParam?.selectPublish}
          getTabs={getTabs}
          onChange={handleOnChange}
          setModalParams={setModalParams}
          importCb={handleImportCb}
          handleSingleImportCb={handleSingleImportCb}
          setImportParams={setImportParams}
          deleteImportProduct={deleteImportProduct}
        />

        {/* 1688 AliExpress导入弹窗 */}
        <ImportFormOther
          data={{
            open: otherImportParams?.open,
            type: otherImportParams?.type,
          }}
          onChange={handleOtherOnChange}
        />
        <ImportAliexpressModal importOpen={aliImportModal} num={100} setImportOpen={setAliImportModal}/>
        {/* ali产品导入限制 */}
        <UpgradePlanModal upgradeOpen={importantDsmModal} setUpgradeOpen={()=>setImportantDsmModal(false)}/>

        {/* 获取好评弹窗 */}
        <GetGoodReviews
          heading_title={intl.get("List Completed!")}
          subtitle={intl.get("Would you mind letting us know what you think about us?")}
          prompt_title={intl.get("Your valuable review will motivate us to improve.")}
          show={reviewParams?.open}
          checkTime={true}
          showTime={reviewParams?.ActiveGetReviewTime}
          callBack={callBackReviewFunc}
        />
       {/* 功能视频介绍 */}
       <NoviceImportModal upgradeOpen={noviceModal} setUpgradeOpen={()=>setNoviceModal(false)}/>

       {/* pagefly 弹窗 */}
       <Modal
            title="Install PageFly to quickly build product pages"
            size='large'
            open={pagefly}
            primaryAction={{
              content: 'Try It For Free Now',
              onAction:()=>{
                window.open('https://pagef.ly/16q24x','_blank');
                handlePageFly(false)
              }
            }}
            secondaryActions={{
              content: 'Cancel',
              onAction:()=>{
                handlePageFly(false)
              }
            }}
            onClose={() => handlePageFly(false)}>
                <div style={{minHeight:"150px"}}>
                <a href="https://pagef.ly/16q24x" target="_blank" rel="noopener noreferrer">
                <img style={{width:'100%',verticalAlign:'bottom'}} src="/affiliate/pagefly.png" alt="dropshipman" />
                </a>
                </div>
            </Modal>
      {/* 提示 */}
      {toastMarkup}
        </Layout>
      </Page>
    </div>
  );

  return isInit ? <LoadingPage /> : pageContent
}

export default withRouter(ImportListClass);
